export default "__VITE_ASSET__CMdv0kfo__"